import $ from 'jquery' // jQuery

import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

//  ###    ###  ##   ##         #####   #####
//  ## #  # ##  ##   ##        ##   ##  ##  ##
//  ##  ##  ##  ##   ##        ##   ##  #####
//  ##      ##   ## ##         ##   ##  ##
//  ##      ##    ###           #####   ##

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.js-header')
  const overlays = document.querySelectorAll('.topMv__overlay--top, .topMv__overlay--bottom')
  const phrases = document.querySelectorAll('.topMvOp--top img, .topMvOp--bottom img')
  const catchphrase = document.querySelector('.topMv__box')
  const isHome = document.body.classList.contains('home')

  // 初回判定（セッション内で1回だけ実行）
  const hasAnimated = sessionStorage.getItem('mvAnimated')

  if (isHome && !hasAnimated) {
    // アニメーション実行済みフラグを立てる
    sessionStorage.setItem('mvAnimated', 'true')

    overlays.forEach((overlay) => {
      overlay.style.height = '100vh'
      overlay.style.transition = 'height 1s ease'
    })

    setTimeout(() => {
      const height = window.innerWidth >= 769 ? '10.416vw' : '18vw'
      overlays.forEach((overlay) => (overlay.style.height = height))
    }, 100)

    setTimeout(() => {
      phrases.forEach((img, index) => {
        img.style.opacity = '0'
        img.style.display = 'block'
        img.style.transition = 'opacity 0.1s'
        setTimeout(() => (img.style.opacity = '1'), index * 180)
      })
    }, 1000)

    setTimeout(() => {
      overlays.forEach((overlay) => {
        overlay.style.opacity = '0'
        overlay.style.transition = 'opacity 1s ease'
      })
    }, 1500 + phrases.length * 200)

    setTimeout(() => {
      ;[header, catchphrase].forEach((el) => {
        if (el) {
          el.style.opacity = '1'
          el.style.transform = 'translate(0, 0)'
        }
      })
    }, 2500 + phrases.length * 200)
  } else {
    // アニメーションなしですぐ表示
    overlays.forEach((overlay) => {
      overlay.style.opacity = '0'
           overlay.style.transition = 'opacity 0s'
    })
    if (header) {
      header.style.opacity = '1'
      header.style.transform = 'translate(0, 0)'
    }
    if (catchphrase) {
      catchphrase.style.opacity = '1'
      catchphrase.style.transform = 'translate(0, 0)'
    }
  }
})

//  ##     ##  #####  ##      ##   ####
//  ####   ##  ##     ##      ##  ##
//  ##  ## ##  #####  ##  ##  ##   ###
//  ##    ###  ##     ##  ##  ##     ##
//  ##     ##  #####   ###  ###   ####

document.addEventListener('DOMContentLoaded', () => {
  if (!document.body.classList.contains('home')) return

  const newsContainer = document.getElementById('news-container')
  const newsLinks = document.querySelectorAll('.js-layerMenu__link')
  const newsList = [...newsContainer.children]

  document.querySelector('.layerMenu').addEventListener('click', (e) => {
    if (!e.target.classList.contains('js-layerMenu__link')) return
    e.preventDefault()

    newsLinks.forEach((link) => link.classList.remove('is_active'))
    e.target.classList.add('is_active')

    const category = e.target.dataset.category
    const filteredNews =
      category === 'all'
        ? newsList
        : newsList.filter(
            (item) => item.querySelector('.js-newsContents__tag').textContent.trim() === e.target.textContent.trim()
          )

    newsContainer.replaceChildren(...filteredNews.map((item) => item.cloneNode(true)))
  })
})

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.js-topCompany__itemLink').forEach(function (itemLink) {
    itemLink.addEventListener('mouseenter', function () {
      itemLink.querySelector('.js-topCompany__img').classList.add('is_active')
    })

    itemLink.addEventListener('mouseleave', function () {
      itemLink.querySelector('.js-topCompany__img').classList.remove('is_active')
    })
  })
})

/*
 ######  ##      ## #### ########  ######## ########
##       ##  ##  ##  ##  ##     ## ##       ##     ##
 ######  ##  ##  ##  ##  ########  ######   ########
      ## ##  ##  ##  ##  ##        ##       ##   ##
 ######   ###  ###  #### ##        ######## ##     ##
*/
if ($('.js-topSocialSlide')[0]) {
  const topSocialSlide = new Swiper('.js-topSocialSlide', {
    loop: false,
    speed: 1000,
    slidesPerView: 'auto', // スライドの幅をCSSで制御
    spaceBetween: 15, // スライド間のスペースを15pxに設定
    autoplay: false,
    pagination: {
      el: '.js-topSocialSlide-pagination',
      clickable: true, // ページネーションをクリック可能にする
    },
    navigation: {
      nextEl: '.swiper-button-next', // 「次へ」ボタン
      prevEl: '.swiper-button-prev', // 「前へ」ボタン
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
      hide: false, // 自動的に消えないようにする
    },
    breakpoints: {
      769: {
        slidesPerView: 'auto',
        spaceBetween: 30, // スライド間のスペースを30pxに設定
      },
    },
    on: {
      init: function () {
        $('.js-topSocialSlide-total').text($('.js-topSocialSlide .swiper-slide').length)
      },
      slideChange: function () {
        $('.js-topSocialSlide-current').text(topSocialSlide.realIndex + 1)
      },
    },
  })
}

if (document.getElementById('page-top')) {
  pageTop()
}

function pageTop() {}

//  #####    #####   ####  #####    ##   ##  ##  ######
//  ##  ##   ##     ##     ##  ##   ##   ##  ##    ##
//  #####    #####  ##     #####    ##   ##  ##    ##
//  ##  ##   ##     ##     ##  ##   ##   ##  ##    ##
//  ##   ##  #####   ####  ##   ##   #####   ##    ##

document.addEventListener('DOMContentLoaded', () => {
  const topRecruit = document.querySelector('.js-topRecruit')
  const topRecruitBg = document.querySelector('.js-topRecruitBg')
  if (!topRecruit || !topRecruitBg) return

  let lists = document.querySelectorAll('.js-topRecruitBg__list')
  let itemWidth = document.querySelector('.js-topRecruitBg__item')?.offsetWidth || 0

  const getInitialOffsets = (width) => {
    if (width >= 2000) return [0, 1]
    if (width >= 1025) return [1, 2]
    if (width >= 769) return [2, 3]
    if (width >= 370) return [1, 3]
    return [2, 3]
  }

  const updateTransform = () => {
    const rect = topRecruitBg.getBoundingClientRect()
    if (rect.top > window.innerHeight || rect.bottom < 0) return

    const [initialOffset, initialOffset02] = getInitialOffsets(window.innerWidth).map((v) => v * itemWidth)
    const moveDistance = window.scrollY * 0.1

    lists.forEach((list, index) => {
      list.style.transform = `translateX(${
        index % 2 === 0 ? initialOffset - moveDistance : -initialOffset02 + moveDistance
      }px)`
      list.style.transition = 'transform 0.1s ease-out'
    })
  }

  const checkScroll = () => {
    const rect = topRecruit.getBoundingClientRect()
    topRecruitBg.classList.toggle('is_active', rect.bottom > 0 && rect.top < window.innerHeight)
  }

  window.addEventListener('scroll', () => {
    updateTransform()
    checkScroll()
  })

  // リサイズ時に初期化＋再始動（0.5秒後）
  let resizeTimeout
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout)
    resizeTimeout = setTimeout(() => {
      // 初期化処理
      lists.forEach((list) => {
        list.style.transform = ''
        list.style.transition = ''
      })

      // 要素再取得（幅変わってるかも）
      itemWidth = document.querySelector('.js-topRecruitBg__item')?.offsetWidth || 0
      lists = document.querySelectorAll('.js-topRecruitBg__list')

      // 再始動
      updateTransform()
      checkScroll()
    }, 500)
  })

  checkScroll() // 初回チェック
})



